var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cargo-shipment-bag-summary"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('legend', [_vm._v("Cargo Shipment Summary")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentMPS),
      expression: "parentMPS"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ParentMPS')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping Id",
      "name": "ParentMPS",
      "id": "ParentMPS"
    },
    domProps: {
      "value": (_vm.parentMPS)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getParentMPSDetails.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentMPS = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.ParentMPSError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ParentMPSErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getParentMPSDetails
    }
  }, [_vm._v("Show Shipment Log")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "-11px"
    }
  }, [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('bagNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "Bag No",
      "id": "bagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getBagDetails.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.ParentAWBError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ParentAWBErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getBagDetails
    }
  }, [_vm._v("Show Bag Log")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "36px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), (_vm.showParentMPSDetailsTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin/Pallet")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletization Log")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ParentMPSDetails), function(MPSData, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.ParentMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": _vm.showShipmentTranscationDetails
      }
    }, [_vm._v(_vm._s(MPSData.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.ServiceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.OriginHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.CurrentHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.FinalDestinationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.PackageDetails.Weight.BillableWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.binnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.palletizedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.palletizedDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.depalletizedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.depalletizedDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showPalletizationLog(MPSData.ShippingId || MPSData.shippingid, 'MPS')
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(MPSData.CreatedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(MPSData.LastModifedDate)))])])
  }), _vm._v(" "), (_vm.ParentMPSDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showBagdetailsTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Seal No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hubname")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hubname")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB Details")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.stoppointhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showParentAWBDetails()
        }
      }
    })])])
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showbagShipmentDetailsModal == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.showbagShipmentDetailsModal),
      callback: function($$v) {
        _vm.showbagShipmentDetailsModal = $$v
      },
      expression: "showbagShipmentDetailsModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closebagShipmentDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent Bagno")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS Counts")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent MPS Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parentAwbDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawbweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentmpsstatus))])])
  }), _vm._v(" "), (_vm.parentAwbDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Paper Work Details"
    },
    model: {
      value: (_vm.showPaperWorkUFModal),
      callback: function($$v) {
        _vm.showPaperWorkUFModal = $$v
      },
      expression: "showPaperWorkUFModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Paper Work Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePaperWorkUFModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paperwork Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paperwork Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.paperWorkUFDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperworkstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperworkshipmentstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperworkcurrenthubName || data.paperworkcurrenthubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), (_vm.paperWorkUFDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]), _vm._v(" "), (_vm.showModalBag == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.showModalBag),
      callback: function($$v) {
        _vm.showModalBag = $$v
      },
      expression: "showModalBag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Audit Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBagModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.auditLog), function(data, index) {
    return (_vm.auditLog.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocationname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showShipmentTranscationTable == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Transactions Log"
    },
    model: {
      value: (_vm.showShipmentTranscationTable),
      callback: function($$v) {
        _vm.showShipmentTranscationTable = $$v
      },
      expression: "showShipmentTranscationTable"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transactions Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.transcationDetails), function(data, index) {
    return (_vm.transcationDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ProcessLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.transcationDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.transcationDetailsForMPSTable == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Transactions Log"
    },
    model: {
      value: (_vm.transcationDetailsForMPSTable),
      callback: function($$v) {
        _vm.transcationDetailsForMPSTable = $$v
      },
      expression: "transcationDetailsForMPSTable"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transactions Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.transcationDetailsForMPS), function(data, index) {
    return (_vm.transcationDetailsForMPS.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ProcessLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.transcationDetailsForMPS.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showPaperBagTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "120px",
      "margin-top": "20px"
    }
  }, [_c('legend', [_vm._v("Paper Work Tracking")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent MPS Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("THC No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("THC Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.paperbagdetails), function(data, index) {
    return (_vm.paperbagdetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentmpsstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.thcno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.thcdate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.finaldestinationName))])]) : _vm._e()
  }), _vm._v(" "), (_vm.paperbagdetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showAWBTrack) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "160px",
      "margin-top": "20px"
    }
  }, [_c('legend', [_vm._v("AWB Tracking "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.showPaperWorkDetailsFromUF(_vm.AWBtrackData.parentMPS || _vm.AWBtrackData.ParentMPS || _vm.parentMPS)
      }
    }
  }, [_vm._v("Paper Work Details")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Child Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Consignee (Name and address)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pigeon Hole")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletization Log")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.parentMPS || _vm.AWBtrackData.ParentMPS))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shipmentTrackData.length))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.clientName) + " (" + _vm._s(_vm.AWBtrackData.clientid) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.childClientName) + " (" + _vm._s(_vm.AWBtrackData.clientbusinessaccountid) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.status))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.servicetype))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.originhubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.currenthubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.shipmentstatus))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.finaldestinationName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.consigneeName) + " (" + _vm._s(_vm.AWBtrackData.consigneeAddress) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.chargeableWeight))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.physicalWeight))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pdd))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pwbinnumber))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pwpalletizedby))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pwpalletizedDate))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pwdepalletizedby))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pwdepalletizedDate))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "fa fa-eye",
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    on: {
      "click": function($event) {
        return _vm.showPalletizationLog(_vm.AWBtrackData.parentMPS || _vm.AWBtrackData.ParentMPS, 'PAPERWORK')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.createddate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.lastmodifieddate)))])]), _vm._v(" "), (_vm.AWBtrackData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "22"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showShipmentTrack) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "180px",
      "margin-top": "20px"
    }
  }, [_c('legend', [_vm._v("MPS Tracking "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.showPalletizationLog(_vm.AWBtrackData.parentMPS || _vm.AWBtrackData.ParentMPS || (_vm.shipmentTrackData[0] && _vm.shipmentTrackData[0].parentMPS), 'PARENT_AWB')
      }
    }
  }, [_vm._v("All MPS Palletization Log")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin/Pallet")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletization Log")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentTrackData), function(data, index) {
    return (_vm.shipmentTrackData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showShipmentTranscationDetailsForMPSTrack(data.shippingid)
        }
      }
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.servicetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.finaldestinationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.palletizedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.palletizedDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.depalletizedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.depalletizedDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showPalletizationLog(data.shippingid, 'MPS')
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.lastmodifieddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.shipmentTrackData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "17"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.showPalletizationLogModal) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Palletization Log"
    },
    model: {
      value: (_vm.showPalletizationLogModal),
      callback: function($$v) {
        _vm.showPalletizationLogModal = $$v
      },
      expression: "showPalletizationLogModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.palletizationLogType === 'PAPERWORK' ? 'Palletization Log (Parent AWB)' : 'Palletization Log (MPS)'))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePalletizationLogModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), (_vm.palletizationLogType === 'MPS') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.palletizationLogType === 'PAPERWORK' ? 'Pigeon Hole' : 'Bin/Pallet'))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletization Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DePalletized Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.palletizationLogRows), function(row, index) {
    return (_vm.palletizationLogRows.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.palletizationLogType === 'MPS') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.mpsId || row.shippingId || '--'))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.binPallet || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getPalletizedLocation(row)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.palletizedby || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.palletizedDate || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.depalletizedby || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.depalletizedDate || '--'))])]) : _vm._e()
  }), _vm._v(" "), (_vm.palletizationLogRows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.palletizationLogType === 'MPS' ? 8 : 7
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d896208","hasScoped":true}!./src/views/components/BagShipmentQuery/CargoShipmentBagSummary/CargoShipmentBagSummary.html
// module id = 1141
// module chunks = 2